import { Button, Typography, useTheme } from '@mui/material';
import { FC } from 'react';
import { Google } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import GMBPlaceholder from '../../assets/images/google_no_content.svg';

interface Props {
  login: () => void;
}

const GoogleMyBusinessLogin: FC<Props> = ({ login }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <>
      <img
        width="300"
        src={GMBPlaceholder}
        alt={t('google_my_business')}
      />
      <Typography
        variant="body2"
        sx={{ mt: theme.spacing(2), mb: theme.spacing(2) }}
      >
        Verknüpfen Sie Ihr Google Konto mit Reputativ, um dieses Modul zu verwenden.
      </Typography>
      <Button
        variant="outlined"
        startIcon={<Google />}
        size="medium"
        onClick={() => login()}
        sx={{ mr: 1 }}
      >
        Mit Google fortfahren
      </Button>
    </>
  );
};

export default GoogleMyBusinessLogin;
